import React, { useContext } from 'react';
import { LinkMenuItem } from '@atlaskit/navigation-system';
import { AnalyticContext } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-recent/src/common/controllers/analytic-context/index.tsx';
import type { JiraOLFItem } from '../../types.tsx';

export function RecentMenuLinkItemAdaptor(params: JiraOLFItem): React.JSX.Element {
	const { href, elemBefore, primaryLabel, secondaryLabel, tertiaryLabel, analytics } = params;

	const description = secondaryLabel
		? `${secondaryLabel}${tertiaryLabel ? ` • ${tertiaryLabel}` : ''}`
		: '';

	const { fireUIAnalyticForRecentItems } = useContext(AnalyticContext);

	return (
		<LinkMenuItem
			elemBefore={elemBefore}
			href={href || ''}
			description={description}
			onClick={() => {
				fireUIAnalyticForRecentItems(analytics);
			}}
		>
			{primaryLabel}
		</LinkMenuItem>
	);
}
